import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

import {
  type PlacementCandidateBanResponse,
  placementCandidateBanResponseSchema,
} from "../types/placementCandidateBan.schema";

export function transformPlacementCandidateBanData(ban: PlacementCandidateBanResponse) {
  return {
    ...ban.data.attributes,
    workerId: ban.data.relationships.worker.data.id,
    id: ban.data.id,
  };
}

export type PlacementCandidateBan = ReturnType<typeof transformPlacementCandidateBanData>;

interface GetPlacementCandidateBanParams {
  banId: string;
}

export function getPlacementCandidateBanUrl(banId: string) {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/placement-candidate-bans/${banId}`;
}

export function useGetPlacementCandidateBan(
  params: GetPlacementCandidateBanParams,
  options?: UseGetQueryOptions<PlacementCandidateBanResponse>
) {
  const { banId } = params;
  return useGetQuery({
    url: getPlacementCandidateBanUrl(banId),
    responseSchema: placementCandidateBanResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PLACEMENT_CANDIDATE_BAN_FAILURE,
      userErrorMessage: "Something went wrong while loading the placement candidate ban.",
    },
    ...options,
  });
}
